import { render } from "./twiga.vue?vue&type=template&id=558ea72d&scoped=true"
import script from "./twiga.vue?vue&type=script&lang=js"
export * from "./twiga.vue?vue&type=script&lang=js"

import "./twiga.vue?vue&type=style&index=0&id=558ea72d&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558ea72d"]])

export default __exports__